module.exports = __webpack_public_path__ + "static/media/referee.b3963079.svg";